import type { ReminderStepRow, InvoiceRow, ProfileRow } from '../types'

export function generateEmailPreview(
  step: ReminderStepRow,
  invoice: InvoiceRow,
  profile?: ProfileRow | null
): { subject: string; body: string } {
  const amountFormatted = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: invoice.currency,
  }).format(invoice.invoice_amount / 100)

  const dueDateFormatted = new Date(invoice.due_date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })

  const senderName = profile?.sender_name || profile?.name || 'Your freelancer'

  const subject = step.subject
  const body = step.body
    .replace(/{{client_name}}/g, invoice.client_name)
    .replace(/{{invoice_label}}/g, invoice.invoice_label)
    .replace(/{{amount}}/g, amountFormatted)
    .replace(/{{due_date}}/g, dueDateFormatted)
    .replace(/{{invoice_link}}/g, invoice.invoice_link)
    .replace(/{{sender_name}}/g, senderName)

  return { subject, body }
}
